import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import {getGPLUCoverageDefinitionPropertyPaths} from '../PropertyPaths';

export const CoverageDefinitionsBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUCoverageDefinitionPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-17bb0943-0981-4fd9-bf7c-2e77e0890233'},
      items: [
        {
          key: '9951ca61-0ef3-4118-850b-b43af8707bcd',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Child Termination Age"
              id={propertyPaths.childTerminationAge}
              value={getQuoteFieldValue(propertyPaths.childTerminationAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.childTerminationAge, Number(e.target.value))}
              type="number"
              disabled
            />
          ),
          props: { xs: 12, sm: 6, md: 6 },
        },
        {
          key: 'a388272f-0da2-4f3e-b9f8-933dbf00ac3c',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Primary Insured Termination Age"
              id={propertyPaths.terminationAge}
              value={getQuoteFieldValue(propertyPaths.terminationAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.terminationAge, Number(e.target.value))}
              type="number"
              required
              disabled
            />
          ),
          props: { xs: 12, sm: 6, md: 6 },
        }
      ],
    },
  ];

  return (
    <FormWrapper title="Coverage Definition" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
